<template>
  <div class="split-vid" :class="{ 'fullscreen' : isFullScreen }" :id="splitId">
    <div v-if="!isFullScreen && !isIos" class="show-fullscreen" @click="makeFullScreen()"></div>
    <div v-if="isFullScreen && !isIos" class="dis-fullscreen" @click="makeNormalScreen()"></div>
    <div v-if="!isIos" class="show-info" @click="showInfoBox = !showInfoBox">?</div>
    <div class="show-info-box" v-if="showInfoBox">
      <div v-html="text"></div>
      <br>
      <a href="#" @click="showInfoBox = !showInfoBox">Close</a>
    </div>
    <div v-if="!isIos" class="muted-button" :class="{ muted: muted}" @click="toggleMuted()"></div>
    <div class="loaded-nr" v-if="loaded < 100 && !isIos">{{ this.loaded }}%</div>
    <Finger :datum="datum" :can-move="canMove" v-if="!isIos"/>
    <div class="movie-container" v-if="isIos">
      <div class="vimeo-container">
        <iframe
          :src="'https://player.vimeo.com/video/' + vimeoId + '?title=0&byline=0&portrait=0'"
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="movie-container first" :id="firstMovId" v-if="!isIos">
      <video
        v-show="currentSize === 'small'"
        :id="firMovId"
        preload="auto"
        class="split-source"
        loop
        autobuffer
        :muted="muted"
        v-bind:style="vid1back"
      ></video>
      <video
        v-show="currentSize === 'large'"
        :id="firMovLargeId"
        preload="auto"
        class="split-source"
        loop
        :muted="muted"
        autobuffer
      ></video>
    </div>
    <div class="movie-container" v-if="!isIos">
      <video
        v-show="currentSize === 'small'"
        :id="secMovId"
        preload="auto"
        class="split-source"
        loop
        autobuffer
        :muted="muted"
        :style="vid2back"
      ></video>
      <video
        v-show="currentSize === 'large'"
        :id="secMovLargeId"
        preload="auto"
        class="split-source"
        loop
        :muted="muted"
        autobuffer
      ></video>
    </div>
  </div>
</template>

<script>
import Finger from '@/components/Finger'
export default {
  name: 'SplitVid',
  data () {
    return {
      splitId: Math.floor(9999 * Math.random()),
      firstMovId: Math.floor(9999 * Math.random()),
      firMovId: Math.floor(9999 * Math.random()),
      secMovId: Math.floor(9999 * Math.random()),
      firMovLargeId: Math.floor(9999 * Math.random()),
      secMovLargeId: Math.floor(9999 * Math.random()),
      vid1back: {},
      vid2back: {},
      msg: 'OnceNature',
      canPlay1: false,
      canPlay2: false,
      currentSize: 'small',
      syncedTimes: 0,
      syncedTimesLarge: 0,
      loader: {},
      loaded: 0,
      xhrrequests: [],
      canMove: false,
      isFullScreen: false,
      showInfoBox: false,
      muted: true
    }
  },
  props: ['firstsmall', 'secondsmall', 'first', 'second', 'firstback', 'secondback', 'datum', 'vimeoId', 'isIos', 'text'],
  computed: {
    canPlay () {
      if (this.canPlay1 && this.canPlay2) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
  },
  methods: {
    toggleMuted () {
      this.muted = !this.muted
    },
    makeNormalScreen () {
      let elem = document
      //  console.log('making it normal', elem)
      if (elem.exitFullscreen) {
        elem.exitFullscreen()
        this.isFullScreen = false
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen()
        this.isFullScreen = false
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen()
        this.isFullScreen = false
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen()
        this.isFullScreen = false
      }
    },
    makeFullScreen () {
      let elem = document.getElementById(this.splitId)
      //  console.log('making it fullscreen', elem)
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
        this.isFullScreen = true
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
        this.isFullScreen = true
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
        this.isFullScreen = true
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
        this.isFullScreen = true
      }
    },
    syncVideos (vid1, vid2) {
      vid2.currentTime = vid1.currentTime
      //  console.log('syncing', vid1)
      //  window.requestAnimationFrame(this.syncVideos(vid1, vid2))
    },
    downloadBackgrounds () {
      let self = this
      let back1 = new Image()
      back1.src = this.firstback
      let back2 = new Image()
      back2.src = this.secondback
      back1.onload = () => {
        self.vid1back.backgroundImage = 'url(' + back1.src + ')'
      }
      back2.onload = () => {
        console.log('Downloaded background-imagem2')
        self.vid2back.backgroundImage = 'url(' + back2.src + ')'
        self.downloadSmallVideos()
      }
    },
    downloadSmallVideos () {
      console.log('Downloading small videos')
      Promise.all([
        this.downloadVideo(this.firstsmall, this.firMovId, true),
        this.downloadVideo(this.secondsmall, this.secMovId, true)
      ]).then(vals => {
        console.log('Downloaded both small videos')
        let vid1 = document.getElementById(this.firMovId)
        let vid2 = document.getElementById(this.secMovId)
        vid2.src = vals[1]
        vid1.src = vals[0]
        let play2 = vid2.play()
        let play1 = vid1.play()
        Promise.all([play1, play2]).then(() => {
          //  console.log('downloaded small videos')
          this.downloadVideos()
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    downloadVideos () {
      Promise.all([
        this.downloadVideo(this.first, this.firMovLargeId, false),
        this.downloadVideo(this.second, this.secMovLargeId, false)
      ]).then(vals => {
        let vidsmall1 = document.getElementById(this.firMovId)
        let vid1 = document.getElementById(this.firMovLargeId)
        let vid2 = document.getElementById(this.secMovLargeId)
        vid1.src = vals[0]
        vid2.src = vals[1]
        let play1 = vid1.play()
        let play2 = vid2.play()
        window.setTimeout(() => {
          this.currentSize = 'large'
          let vid1Small = document.getElementById(this.firMovId)
          let vid2Small = document.getElementById(this.secMovId)
          vid1Small.volume = 0
          vid2Small.volume = 0
          vid1Small.pause()
          vid2Small.pause()
        }, 1000)
        Promise.all([play1, play2]).then(() => {
          vid1.currentTime = vidsmall1.currentTime + 0.1
          vid2.currentTime = vidsmall1.currentTime + 0.1
          //  console.log('downloaded and playing large videos')
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    downloadVideo (url, id, first) {
      let self = this
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        self.xhrrequests.push(xhr)
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.addEventListener('progress', (evt) => {
          if (first) {
            this.loader[id] = (evt.loaded / evt.total) * 100
            this.loaded = Math.round(0.5 * Object.keys(this.loader).map(key => this.loader[key]).reduce((a, v) => { return a + v }, 0))
          }
        })
        xhr.onload = function (e) {
          if (this.status === 200) {
            var myBlob = this.response
            var vid = (window.webkitURL ? window.webkitURL : window.URL).createObjectURL(myBlob)
            //  var video = document.getElementById(id)
            //  video.src = vid
            console.log('Downloaded === ' + id)
            resolve(vid)
          } else {
            reject(Error('Did not find file'))
          }
        }
        xhr.onerror = function () {
          reject(Error('Network error'))
        }
        xhr.onabort = function () {
          console.log('Aborted download')
          reject(Error('Aborted'))
        }
        xhr.send()
      })
    }
  },
  beforeMount () {
  },
  mounted () {
    let self = this
    window.setTimeout(() => {
      self.canMove = true
    }, 1000)
    //  console.log('mounted with ', this.firstsmall)
    let container = document.getElementById(this.splitId)
    let videoDiv = document.getElementById(this.firstMovId)
    this.$nextTick(() => {
      //  this.downloadSmallVideos()
      this.downloadBackgrounds()
    })
    let vid1 = document.getElementById(this.firMovId)
    let vid2 = document.getElementById(this.secMovId)
    let vid1Large = document.getElementById(this.firMovLargeId)
    let vid2Large = document.getElementById(this.secMovLargeId)
    this.$nextTick(() => {
      videoDiv.style.width = (container.offsetWidth / 2) + 'px'
    })
    vid2.addEventListener('timeupdate', () => {
      if (this.syncedTimes < 3 && vid1.currentTime > 0.6) {
        //  console.log('syncing small', vid1.currentTime + ' -- ' + vid2.currentTime)
        let setToThis = vid1.currentTime
        vid1.currentTime = setToThis
        vid2.currentTime = setToThis
        this.syncedTimes++
      }
      if (vid1.currentTime <= 0.6) {
        this.syncedTimes = 0
      }
      //  console.log('')
    })
    vid2Large.addEventListener('timeupdate', () => {
      if (this.syncedTimesLarge < 3 && vid1Large.currentTime > 0.6) {
        // console.log('sycning large', vid1Large.currentTime + ' -- ' + vid2Large.currentTime)
        let setToThis = vid2Large.currentTime
        vid1Large.currentTime = setToThis
        vid2Large.currentTime = setToThis
        this.syncedTimesLarge++
      }
      if (vid1Large.currentTime <= 0.6) {
        this.syncedTimesLarge = 0
      }
      //  console.log('got timeupdate event')
    })
    container.onmousemove = (e) => {
      if (!this.canMove) {
        return
      }
      let w = e.pageX - container.offsetLeft
      let total = container.offsetWidth
      let proc = w / total
      if (proc > 1) {
        proc = 1
      }
      if (proc < 0.1) {
        proc = 0
      }
      vid1.volume = proc
      vid1Large.volume = proc
      let largeProc = 1 - (w / total)
      if (largeProc > 1) {
        largeProc = 1
      }
      if (largeProc < 0.1) {
        largeProc = 0
      }
      vid2Large.volume = largeProc
      vid2.volume = largeProc
      videoDiv.style.width = w + 'px'
    }
    container.onmouseout = (e) => {
      document.body.className = ''
    }
    container.onmouseover = (e) => {
      document.body.className = 'dissar-active'
    }
    container.addEventListener('touchmove', (e) => {
      if (!this.canMove) {
        return
      }
      let touch = e.touches[0]
      let w = touch.pageX - container.offsetLeft
      let total = container.offsetWidth
      let proc = w / total
      vid1.volume = proc
      vid1Large.volume = proc
      if (proc < 0.1) {
        vid1Large.volume = 0
        vid1.volume = 0
      }
      vid2Large.volume = 1 - proc
      vid2.volume = 1 - proc
      videoDiv.style.width = w + 'px'
    })

    if (window.innerWidth < 1100) {
      vid1.muted = true
      vid2.muted = true
      vid1Large.muted = true
      vid2Large.muted = true
    }
  },
  beforeDestroy () {
    this.xhrrequests.map(a => {
      a.abort()
      //  console.log('aborting ', a)
      return {}
    })
    let container = document.getElementById(this.splitId)
    let videoDiv = document.getElementById(this.firstMovId)
    videoDiv.style.width = (container.offsetWidth / 2) + 'px'
  },
  components: {Finger}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.show-info {
  position: absolute;
  right: 120px;
  color: #fff;
  font-size: 1.3em;
  opacity: 0.5;
  bottom: 10px;
  z-index: 99999999;
  transition: all 0.2s ease;
  cursor: pointer;
}
.muted-button {
  position: absolute;
  right: 155px;
  font-size: 1.3em;
  opacity: 0.7;
  bottom: 10px;
  z-index: 99999999;
  transition: all 0.2s ease;
  cursor: pointer;
  height: 24px;
  width: 28px;
  background-image: url("../assets/UnMuteOncenature.svg");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: left top;
}
.muted-button.muted {
  background-image: url("../assets/MuteOncenature.svg");
}
.show-info-box {
  position: absolute;
  bottom: 10px;
  right: 10px;
  top: 10px;
  left: 10px;
  background-color: grey;
  color: #fff;
  padding: 16px 20px;
  font-size: 16px;
  line-height: 18px;
  text-align: left;
  max-height: 100%;
  overflow-y: scroll;
  z-index: 99999999;
}
.show-fullscreen,
.dis-fullscreen {
  position: absolute;
  z-index: 9999999;
  bottom: 10px;
  right: 70px;
  transition: all 0.2s ease;
  cursor: pointer;
  width: 25px;
  height: 25px;
  opacity: 0.6;
}
.show-fullscreen {
  background-image: url("../assets/helskarm_ut.svg");
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
.dis-fullscreen {
  background-image: url("../assets/helskarm_in.svg");
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
.show-fullscreen:hover,
.dis-fullscreen:hover,
.show-info:hover,
.muted-button:hover {
  transform: scale(1.05);
  opacity: 1;
}
.loaded-nr {
  position: absolute;
  z-index: 99999;
  bottom: 10px;
  right: 4vw;
  color: #fff;
}
.split-vid {
  height: 400px;
  width: 800px;
  overflow: hidden;
  position: relative;
}
.fullscreen .split-vid {
  width: 100vw;
  height: 100vh;
}
.movie-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.movie-container video,
.vimeo-container {
  width: 800px;
  height: 400px;
  opacity: 1;
  transition: opacity 1s;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
.fullscreen .movie-container video,
.fullscreen .vimeo-container {
  width: 100vw;
  height: 100vh;
}
.vimeo-container {
  width: 760px;
  padding-left: 20px;
}
.movie-container video.nullopac {
  opacity: 0;
  transition: opacity 5s;
}
.movie-container.first {
  width: 50%;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/SplitVid.vue